import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { LoginForm } from '@/components/LoginForm'
import { DeviceList } from '@/components/DeviceList'
import { DevicePage } from '@/components/DevicePage'
import { MembersPage } from '@/components/MembersPage'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginForm />} />
      <Route path="/" element={<Navigate to="/sightings" replace />} />
      <Route path="/devices" element={<ProtectedRoute><DeviceList /></ProtectedRoute>} />
      <Route path="/feed" element={<ProtectedRoute><DeviceList /></ProtectedRoute>} />
      <Route path="/sightings" element={<ProtectedRoute><DeviceList /></ProtectedRoute>} />
      <Route path="/sightings/:sightingId" element={<ProtectedRoute><DeviceList /></ProtectedRoute>} />
      <Route path="/persons" element={<ProtectedRoute><DeviceList /></ProtectedRoute>} />
      <Route path="/persons/:personId" element={<ProtectedRoute><DeviceList /></ProtectedRoute>} />
      <Route path="/suggestions" element={<ProtectedRoute><DeviceList /></ProtectedRoute>} />
      <Route path="/classifications" element={<ProtectedRoute><DeviceList /></ProtectedRoute>} />
      <Route path="/members" element={<ProtectedRoute><MembersPage /></ProtectedRoute>} />
      <Route path="/device/:deviceId" element={<ProtectedRoute><DevicePage /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/sightings" replace />} />
    </Routes>
  )
}

export default App
